/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({
    "data": {
      "categories": {
        "cardinal": ["one", "other"],
        "ordinal": ["one", "other"]
      },
      "fn": function fn(n, ord) {
        var s = String(n).split('.'),
          t0 = Number(s[0]) == n;
        if (ord) return t0 && n >= 1 && n <= 4 ? 'one' : 'other';
        return n == 1 ? 'one' : 'other';
      }
    },
    "locale": "ne"
  });
}